// extracted by mini-css-extract-plugin
export default {"gif_invert":"Header_gif_invert__zFO-U"};